import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as strings from '../../../base/common/strings.js';
import { EditOperation } from '../../common/core/editOperation.js';
import { Position } from '../../common/core/position.js';
import { Range } from '../../common/core/range.js';
import { Selection } from '../../common/core/selection.js';
import { LanguageConfigurationRegistry } from '../../common/modes/languageConfigurationRegistry.js';
import { BlockCommentCommand } from './blockCommentCommand.js';
export var LineCommentCommand = /*#__PURE__*/function () {
  function LineCommentCommand(selection, tabSize, type, insertSpace, ignoreEmptyLines) {
    _classCallCheck(this, LineCommentCommand);

    this._selection = selection;
    this._tabSize = tabSize;
    this._type = type;
    this._insertSpace = insertSpace;
    this._selectionId = null;
    this._deltaColumn = 0;
    this._moveEndPositionDown = false;
    this._ignoreEmptyLines = ignoreEmptyLines;
  }
  /**
   * Do an initial pass over the lines and gather info about the line comment string.
   * Returns null if any of the lines doesn't support a line comment string.
   */


  _createClass(LineCommentCommand, [{
    key: "_executeLineComments",
    value:
    /**
     * Given a successful analysis, execute either insert line comments, either remove line comments
     */
    function _executeLineComments(model, builder, data, s) {
      var ops;

      if (data.shouldRemoveComments) {
        ops = LineCommentCommand._createRemoveLineCommentsOperations(data.lines, s.startLineNumber);
      } else {
        LineCommentCommand._normalizeInsertionPoint(model, data.lines, s.startLineNumber, this._tabSize);

        ops = this._createAddLineCommentsOperations(data.lines, s.startLineNumber);
      }

      var cursorPosition = new Position(s.positionLineNumber, s.positionColumn);

      for (var i = 0, len = ops.length; i < len; i++) {
        builder.addEditOperation(ops[i].range, ops[i].text);

        if (Range.isEmpty(ops[i].range) && Range.getStartPosition(ops[i].range).equals(cursorPosition)) {
          var lineContent = model.getLineContent(cursorPosition.lineNumber);

          if (lineContent.length + 1 === cursorPosition.column) {
            this._deltaColumn = (ops[i].text || '').length;
          }
        }
      }

      this._selectionId = builder.trackSelection(s);
    }
  }, {
    key: "_attemptRemoveBlockComment",
    value: function _attemptRemoveBlockComment(model, s, startToken, endToken) {
      var startLineNumber = s.startLineNumber;
      var endLineNumber = s.endLineNumber;
      var startTokenAllowedBeforeColumn = endToken.length + Math.max(model.getLineFirstNonWhitespaceColumn(s.startLineNumber), s.startColumn);
      var startTokenIndex = model.getLineContent(startLineNumber).lastIndexOf(startToken, startTokenAllowedBeforeColumn - 1);
      var endTokenIndex = model.getLineContent(endLineNumber).indexOf(endToken, s.endColumn - 1 - startToken.length);

      if (startTokenIndex !== -1 && endTokenIndex === -1) {
        endTokenIndex = model.getLineContent(startLineNumber).indexOf(endToken, startTokenIndex + startToken.length);
        endLineNumber = startLineNumber;
      }

      if (startTokenIndex === -1 && endTokenIndex !== -1) {
        startTokenIndex = model.getLineContent(endLineNumber).lastIndexOf(startToken, endTokenIndex);
        startLineNumber = endLineNumber;
      }

      if (s.isEmpty() && (startTokenIndex === -1 || endTokenIndex === -1)) {
        startTokenIndex = model.getLineContent(startLineNumber).indexOf(startToken);

        if (startTokenIndex !== -1) {
          endTokenIndex = model.getLineContent(startLineNumber).indexOf(endToken, startTokenIndex + startToken.length);
        }
      } // We have to adjust to possible inner white space.
      // For Space after startToken, add Space to startToken - range math will work out.


      if (startTokenIndex !== -1 && model.getLineContent(startLineNumber).charCodeAt(startTokenIndex + startToken.length) === 32
      /* Space */
      ) {
        startToken += ' ';
      } // For Space before endToken, add Space before endToken and shift index one left.


      if (endTokenIndex !== -1 && model.getLineContent(endLineNumber).charCodeAt(endTokenIndex - 1) === 32
      /* Space */
      ) {
        endToken = ' ' + endToken;
        endTokenIndex -= 1;
      }

      if (startTokenIndex !== -1 && endTokenIndex !== -1) {
        return BlockCommentCommand._createRemoveBlockCommentOperations(new Range(startLineNumber, startTokenIndex + startToken.length + 1, endLineNumber, endTokenIndex + 1), startToken, endToken);
      }

      return null;
    }
    /**
     * Given an unsuccessful analysis, delegate to the block comment command
     */

  }, {
    key: "_executeBlockComment",
    value: function _executeBlockComment(model, builder, s) {
      model.tokenizeIfCheap(s.startLineNumber);
      var languageId = model.getLanguageIdAtPosition(s.startLineNumber, 1);
      var config = LanguageConfigurationRegistry.getComments(languageId);

      if (!config || !config.blockCommentStartToken || !config.blockCommentEndToken) {
        // Mode does not support block comments
        return;
      }

      var startToken = config.blockCommentStartToken;
      var endToken = config.blockCommentEndToken;

      var ops = this._attemptRemoveBlockComment(model, s, startToken, endToken);

      if (!ops) {
        if (s.isEmpty()) {
          var lineContent = model.getLineContent(s.startLineNumber);
          var firstNonWhitespaceIndex = strings.firstNonWhitespaceIndex(lineContent);

          if (firstNonWhitespaceIndex === -1) {
            // Line is empty or contains only whitespace
            firstNonWhitespaceIndex = lineContent.length;
          }

          ops = BlockCommentCommand._createAddBlockCommentOperations(new Range(s.startLineNumber, firstNonWhitespaceIndex + 1, s.startLineNumber, lineContent.length + 1), startToken, endToken, this._insertSpace);
        } else {
          ops = BlockCommentCommand._createAddBlockCommentOperations(new Range(s.startLineNumber, model.getLineFirstNonWhitespaceColumn(s.startLineNumber), s.endLineNumber, model.getLineMaxColumn(s.endLineNumber)), startToken, endToken, this._insertSpace);
        }

        if (ops.length === 1) {
          // Leave cursor after token and Space
          this._deltaColumn = startToken.length + 1;
        }
      }

      this._selectionId = builder.trackSelection(s);

      var _iterator = _createForOfIteratorHelper(ops),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var op = _step.value;
          builder.addEditOperation(op.range, op.text);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "getEditOperations",
    value: function getEditOperations(model, builder) {
      var s = this._selection;
      this._moveEndPositionDown = false;

      if (s.startLineNumber < s.endLineNumber && s.endColumn === 1) {
        this._moveEndPositionDown = true;
        s = s.setEndPosition(s.endLineNumber - 1, model.getLineMaxColumn(s.endLineNumber - 1));
      }

      var data = LineCommentCommand._gatherPreflightData(this._type, this._insertSpace, model, s.startLineNumber, s.endLineNumber, this._ignoreEmptyLines);

      if (data.supported) {
        return this._executeLineComments(model, builder, data, s);
      }

      return this._executeBlockComment(model, builder, s);
    }
  }, {
    key: "computeCursorState",
    value: function computeCursorState(model, helper) {
      var result = helper.getTrackedSelection(this._selectionId);

      if (this._moveEndPositionDown) {
        result = result.setEndPosition(result.endLineNumber + 1, 1);
      }

      return new Selection(result.selectionStartLineNumber, result.selectionStartColumn + this._deltaColumn, result.positionLineNumber, result.positionColumn + this._deltaColumn);
    }
    /**
     * Generate edit operations in the remove line comment case
     */

  }, {
    key: "_createAddLineCommentsOperations",
    value:
    /**
     * Generate edit operations in the add line comment case
     */
    function _createAddLineCommentsOperations(lines, startLineNumber) {
      var res = [];
      var afterCommentStr = this._insertSpace ? ' ' : '';

      for (var i = 0, len = lines.length; i < len; i++) {
        var lineData = lines[i];

        if (lineData.ignore) {
          continue;
        }

        res.push(EditOperation.insert(new Position(startLineNumber + i, lineData.commentStrOffset + 1), lineData.commentStr + afterCommentStr));
      }

      return res;
    }
  }], [{
    key: "_gatherPreflightCommentStrings",
    value: function _gatherPreflightCommentStrings(model, startLineNumber, endLineNumber) {
      model.tokenizeIfCheap(startLineNumber);
      var languageId = model.getLanguageIdAtPosition(startLineNumber, 1);
      var config = LanguageConfigurationRegistry.getComments(languageId);
      var commentStr = config ? config.lineCommentToken : null;

      if (!commentStr) {
        // Mode does not support line comments
        return null;
      }

      var lines = [];

      for (var i = 0, lineCount = endLineNumber - startLineNumber + 1; i < lineCount; i++) {
        lines[i] = {
          ignore: false,
          commentStr: commentStr,
          commentStrOffset: 0,
          commentStrLength: commentStr.length
        };
      }

      return lines;
    }
    /**
     * Analyze lines and decide which lines are relevant and what the toggle should do.
     * Also, build up several offsets and lengths useful in the generation of editor operations.
     */

  }, {
    key: "_analyzeLines",
    value: function _analyzeLines(type, insertSpace, model, lines, startLineNumber, ignoreEmptyLines) {
      var onlyWhitespaceLines = true;
      var shouldRemoveComments;

      if (type === 0
      /* Toggle */
      ) {
        shouldRemoveComments = true;
      } else if (type === 1
      /* ForceAdd */
      ) {
        shouldRemoveComments = false;
      } else {
        shouldRemoveComments = true;
      }

      for (var i = 0, lineCount = lines.length; i < lineCount; i++) {
        var lineData = lines[i];
        var lineNumber = startLineNumber + i;
        var lineContent = model.getLineContent(lineNumber);
        var lineContentStartOffset = strings.firstNonWhitespaceIndex(lineContent);

        if (lineContentStartOffset === -1) {
          // Empty or whitespace only line
          lineData.ignore = ignoreEmptyLines;
          lineData.commentStrOffset = lineContent.length;
          continue;
        }

        onlyWhitespaceLines = false;
        lineData.ignore = false;
        lineData.commentStrOffset = lineContentStartOffset;

        if (shouldRemoveComments && !BlockCommentCommand._haystackHasNeedleAtOffset(lineContent, lineData.commentStr, lineContentStartOffset)) {
          if (type === 0
          /* Toggle */
          ) {
            // Every line so far has been a line comment, but this one is not
            shouldRemoveComments = false;
          } else if (type === 1
          /* ForceAdd */
          ) {// Will not happen
          } else {
            lineData.ignore = true;
          }
        }

        if (shouldRemoveComments && insertSpace) {
          // Remove a following space if present
          var commentStrEndOffset = lineContentStartOffset + lineData.commentStrLength;

          if (commentStrEndOffset < lineContent.length && lineContent.charCodeAt(commentStrEndOffset) === 32
          /* Space */
          ) {
            lineData.commentStrLength += 1;
          }
        }
      }

      if (type === 0
      /* Toggle */
      && onlyWhitespaceLines) {
        // For only whitespace lines, we insert comments
        shouldRemoveComments = false; // Also, no longer ignore them

        for (var _i = 0, _lineCount = lines.length; _i < _lineCount; _i++) {
          lines[_i].ignore = false;
        }
      }

      return {
        supported: true,
        shouldRemoveComments: shouldRemoveComments,
        lines: lines
      };
    }
    /**
     * Analyze all lines and decide exactly what to do => not supported | insert line comments | remove line comments
     */

  }, {
    key: "_gatherPreflightData",
    value: function _gatherPreflightData(type, insertSpace, model, startLineNumber, endLineNumber, ignoreEmptyLines) {
      var lines = LineCommentCommand._gatherPreflightCommentStrings(model, startLineNumber, endLineNumber);

      if (lines === null) {
        return {
          supported: false
        };
      }

      return LineCommentCommand._analyzeLines(type, insertSpace, model, lines, startLineNumber, ignoreEmptyLines);
    }
  }, {
    key: "_createRemoveLineCommentsOperations",
    value: function _createRemoveLineCommentsOperations(lines, startLineNumber) {
      var res = [];

      for (var i = 0, len = lines.length; i < len; i++) {
        var lineData = lines[i];

        if (lineData.ignore) {
          continue;
        }

        res.push(EditOperation.delete(new Range(startLineNumber + i, lineData.commentStrOffset + 1, startLineNumber + i, lineData.commentStrOffset + lineData.commentStrLength + 1)));
      }

      return res;
    }
  }, {
    key: "nextVisibleColumn",
    value: function nextVisibleColumn(currentVisibleColumn, tabSize, isTab, columnSize) {
      if (isTab) {
        return currentVisibleColumn + (tabSize - currentVisibleColumn % tabSize);
      }

      return currentVisibleColumn + columnSize;
    }
    /**
     * Adjust insertion points to have them vertically aligned in the add line comment case
     */

  }, {
    key: "_normalizeInsertionPoint",
    value: function _normalizeInsertionPoint(model, lines, startLineNumber, tabSize) {
      var minVisibleColumn = 1073741824
      /* MAX_SAFE_SMALL_INTEGER */
      ;
      var j;
      var lenJ;

      for (var i = 0, len = lines.length; i < len; i++) {
        if (lines[i].ignore) {
          continue;
        }

        var lineContent = model.getLineContent(startLineNumber + i);
        var currentVisibleColumn = 0;

        for (var _j = 0, _lenJ = lines[i].commentStrOffset; currentVisibleColumn < minVisibleColumn && _j < _lenJ; _j++) {
          currentVisibleColumn = LineCommentCommand.nextVisibleColumn(currentVisibleColumn, tabSize, lineContent.charCodeAt(_j) === 9
          /* Tab */
          , 1);
        }

        if (currentVisibleColumn < minVisibleColumn) {
          minVisibleColumn = currentVisibleColumn;
        }
      }

      minVisibleColumn = Math.floor(minVisibleColumn / tabSize) * tabSize;

      for (var _i2 = 0, _len = lines.length; _i2 < _len; _i2++) {
        if (lines[_i2].ignore) {
          continue;
        }

        var _lineContent = model.getLineContent(startLineNumber + _i2);

        var _currentVisibleColumn = 0;

        for (j = 0, lenJ = lines[_i2].commentStrOffset; _currentVisibleColumn < minVisibleColumn && j < lenJ; j++) {
          _currentVisibleColumn = LineCommentCommand.nextVisibleColumn(_currentVisibleColumn, tabSize, _lineContent.charCodeAt(j) === 9
          /* Tab */
          , 1);
        }

        if (_currentVisibleColumn > minVisibleColumn) {
          lines[_i2].commentStrOffset = j - 1;
        } else {
          lines[_i2].commentStrOffset = j;
        }
      }
    }
  }]);

  return LineCommentCommand;
}();